/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from 'react';
import { useEffect, useState } from 'react';

import { useIsAuthenticated } from '@azure/msal-react';
import { ToastContainer, toast } from 'react-toastify';

import { MDBContainer, MDBRow, MDBCol } from "mdbreact";


import "./AzureHeader.css";
import Header from '../Header';
import Footer from "../Footer.js";

import intelImage from "../images/intel-header-logo.svg";
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';
/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
  
  const [displayName, setDisplayName] = useState(null);
  
  const isAuthenticated = useIsAuthenticated();
 
    
    return (
      <>
       
          <ToastContainer />
          <nav className="navbar navbar-default fixed-menu" style={{position: "fixed"}}>
              <div className="container-fluid">
                  <div className="navbar-header">
                      <div>
                      <a
                              href="http://www.intel.com/content/www/us/en/homepage.html"
                              target="_blank"
                          >
                              <img className="navbar-logo" style={{float: "left",height: "45px",padding: "5px"}} src={intelImage} alt="" />
                          </a>
                          <a className="navbar-brand" href="/NCRMHome">
                              &nbsp;
                              <label className="IntelTitle" style={{fontSize: "24px", fontWeight: 400,color: "#e9e9e9", lineHeight: "14px"}}>
                              Transportation Management System
                              </label>
                          </a>
                      </div>
                  </div>
                  <div className="navbar-right" style={{ position: "relative", color: "#e9e9e9" }}>
                      <label className="navbar-text" style={{ position: "relative", color: "#ffffff",fontWeight: 500,fontSize: "14px", lineHeight: "14px" }}> 
                       {isAuthenticated ? <SignOutButton />: <SignInButton />}
                  </label>
                  </div>
                </div>
          </nav>
          <Header />
          <div id="content" className="container-fluid">
              <div id="custom-move-Menu">
                <button
                  type="button"
                  id="sidebarCollapse"
                  className="navbar-btn cstbtn"
                >
                  <i id="rightpanel" className="fa fa-angle-double-right"></i>
                  <i id="leftpanel" className="fa fa-angle-double-left"></i>
                </button>

                <div className="">
                {props.children}
                </div>
              </div>

              <MDBContainer fluid>
                <MDBRow>
                  <MDBCol>
                    <Footer />
                  </MDBCol>
                </MDBRow>
              </MDBContainer>
            </div>
          


        </>
    )
};
